import { events } from '@/app/events/events';
import { sheets } from '@/app/grid/controller/Sheets';
import type { JsTableInfo } from '@/app/quadratic-core-types';
import { atom, getDefaultStore } from 'jotai';

export const defaultTableInfo: JsTableInfo[] = [];

export const tableInfoAtom = atom<JsTableInfo[]>(defaultTableInfo);

let tableInfoListenersInitialized = false;

export const initTableInfoListeners = () => {
  if (tableInfoListenersInitialized) return () => {};
  tableInfoListenersInitialized = true;

  const store = getDefaultStore();

  const sync = () => {
    let tableInfo: JsTableInfo[] = [];
    try {
      tableInfo = sheets.getTableInfo();
    } catch (e) {
      console.error('Error getting table info in tableInfoAtom.ts', e);
    }
    tableInfo.sort((a, b) => a.name.localeCompare(b.name));
    store.set(tableInfoAtom, tableInfo);
  };

  sync();

  events.on('a1ContextUpdated', sync);
  return () => {
    events.off('a1ContextUpdated', sync);
    tableInfoListenersInitialized = false;
  };
};
